import BankAccountRatio from './bank-account-ratio';

export default BankAccountRatio;
